<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>申诉审批</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-card shadow="hover">
      <!-- 搜索 -->
      <el-form :inline="true" size="small" v-model="listQuery">
        <el-form-item label="城市">
          <el-select
            v-model="listQuery.cityId"
            clearable
            placeholder="请选择城市"
            @change="cityChange"
          >
            <el-option
              v-for="(item, index) in cityList"
              :key="index"
              :label="item.cityAddress"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务站">
          <el-select
            v-model="listQuery.stationId"
            clearable
            placeholder="请选择服务站"
          >
            <el-option
              v-for="(item, index) in stationList"
              :key="index"
              :label="item.stationName"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服务者">
          <el-input
            v-model="listQuery.name"
            placeholder="请输入服务者姓名"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="手机号">
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="审核类型">
          <el-select
            v-model="listQuery.type"
            placeholder="请选择类型"
            clearable
          >
            <el-option value="1" label="初审"></el-option>
            <el-option value="2" label="复审"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="一级审批状态">
          <el-select
            v-model="listQuery.firstAuditStatus"
            placeholder="请选择类型"
            clearable
          >
            <el-option :value="1" label="待审核"></el-option>
            <el-option :value="2" label="审核通过"></el-option>
            <el-option :value="3" label="驳回"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级审批状态">
          <el-select
            v-model="listQuery.secondAuditStatus"
            placeholder="请选择类型"
            clearable
          >
            <el-option :value="1" label="待审核"></el-option>
            <el-option :value="2" label="审核通过"></el-option>
            <el-option :value="3" label="驳回"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建时间段">
          <el-date-picker
            v-model="listQuery.timePart"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            :picker-options="pickerOptions"
          ></el-date-picker>
        </el-form-item>

        <el-form-item>
          <el-button
            icon="el-icon-search"
            type="primary"
            plan
            @click="querySearch"
            >查询</el-button
          >
        </el-form-item>
      </el-form>

      <!-- 列表数据 -->
      <el-table :data="listData" border style="width: 100%" class="table">
        <el-table-column
          prop="id"
          label="ID"
          width="50px"
          fixed="left"
        ></el-table-column>

        <el-table-column
          prop="serverId"
          label="编号"
          width="100px"
          fixed="left"
        ></el-table-column>
        <el-table-column prop="name" label="服务者姓名"></el-table-column>
        <el-table-column prop="cityName" label="城市"></el-table-column>
        <el-table-column prop="stationName" label="服务站"></el-table-column>
        <el-table-column prop="serverPhone" label="手机号"></el-table-column>
        <el-table-column prop="type" label="申诉类型">
          <template slot-scope="scope">
            <span>{{ typeMap[scope.row.type] }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="relationId" label="明细Id">
          <template slot-scope="scope">
            <el-button type="text" @click="salaryDetail(scope.row)">{{
              scope.row.relationId
            }}</el-button>
          </template>
        </el-table-column>
        <el-table-column
          prop="objectionDate"
          label="异议日期"
        ></el-table-column>
        <el-table-column prop="complainFee" label="申诉金额"></el-table-column>
        <el-table-column
          prop="correctErrorFee"
          label="应该修正金额"
        ></el-table-column>
        <el-table-column prop="affirmFee" label="最终认定金额"></el-table-column>
        <el-table-column prop="complainDesc" label="申诉描述" width="400px"></el-table-column>
        <el-table-column prop="relationId" label="关联明细id"></el-table-column>
        <el-table-column prop="firstAuditStatus" label="一级审批状态">
          <template slot-scope="scope">
            <span v-if="scope.row.firstAuditStatus == 1">待审核</span>
            <span v-if="scope.row.firstAuditStatus == 2">审核通过</span>
            <span v-if="scope.row.firstAuditStatus == 3">驳回</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="firstRejectReason"
          label="一级驳回理由"
        ></el-table-column>
        <el-table-column
          prop="firstAuditOfficer"
          label="一级审核官id"
        ></el-table-column>

        <el-table-column
          prop="firstAuditTime"
          label="一级审批时间"
          :formatter="dateFormatB"
        ></el-table-column>
        <el-table-column prop="firstAuditStatus" label="二级审批状态">
          <template slot-scope="scope">
            <span v-if="scope.row.secondAuditStatus == 1">待审核</span>
            <span v-if="scope.row.secondAuditStatus == 2">审核通过</span>
            <span v-if="scope.row.secondAuditStatus == 3">驳回</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="secondRejectReason"
          label="二级驳回理由"
        ></el-table-column>
        <el-table-column
          prop="secondAuditOfficer"
          label="二级审核官id"
        ></el-table-column>

        <el-table-column
          prop="secondAuditTime"
          label="二级审批时间"
          :formatter="dateFormatB"
        ></el-table-column>

        <el-table-column prop="files" label="附件" width="200px">
          <template slot-scope="scope">
            <span v-if="scope.row.files == ''">无</span>
            <el-image
              v-else
              slot="reference"
              :preview-src-list="scope.row.files.split(',')"
              v-for="item in scope.row.files.split(',')"
              :key="item.index"
              :src="item"
            ></el-image>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="objectionDate" label="异议时间" :formatter="dateFormatA" width="140px"></el-table-column> -->
        <el-table-column prop="remark" label="备注"></el-table-column>
        <el-table-column
          prop="createTime"
          label="创建时间"
          :formatter="dateFormatA"
          width="140px"
        ></el-table-column>
        <!-- <el-table-column prop="updateTime" label="更新时间" :formatter="dateFormatA" width="140px"></el-table-column> -->

        <el-table-column
          prop
          label="操作"
          fixed="right"
          width="150px"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="showAuditDetail(scope.row)"
              >审核轨迹</el-button
            >
            <el-button
              type="text"
              @click="auditShow(scope.row)"
              :disabled="!(scope.row.firstAuditStatus == '1')"
              v-per="'salaryOneAudit'"
              >初审</el-button
            >
            <el-button
              type="text"
              @click="auditShow(scope.row)"
              :disabled="!(scope.row.secondAuditStatus == '1')"
              v-per="'salarySecondAudit'"
              >复审</el-button
            >
            <el-button
              type="text"
              @click="addComplain(scope.row)"
              :disabled="
                !(
                  scope.row.firstAuditStatus == '3' ||
                  scope.row.secondAuditStatus == '3'
                )
              "
              v-per="'salaryAuditAgain'"
              >申诉</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination
        :total="total"
        :page.sync="currentPage"
        :limit.sync="pageSize"
        @pagination="querySearch"
      />
    </el-card>

    <el-dialog
      title="审核"
      :visible.sync="auditVisible"
      width="600px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="auditForm"
        :inline="true"
        :model="auditForm"
        label-width="120px"
        :rules="auditRules"
      >
        <el-form-item label="处理决定" prop="result">
          <el-select v-model="auditForm.result" placeholder="请选择处理决定">
            <el-option label="通过" value="2"></el-option>
            <el-option label="驳回" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="裁定金额" prop="affirmFee">
          <!-- style="width:215px" -->
          <el-input v-model="auditForm.affirmFee" clearable></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="mark" v-if="auditForm.result == '3'">
          <el-input
            type="textarea"
            style="width:400px"
            :rows="3"
            placeholder="请输入驳回理由"
            v-model="auditForm.rejectReason"
          ></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="auditVisible = false">取消</el-button>
        <el-button type="primary" @click="confAudit()">确定</el-button>
      </span>
    </el-dialog>

    <!-- 审核轨迹  -->
    <el-dialog
      title="审核轨迹"
      :visible.sync="auditStepVisible"
      width="500px"
      :close-on-click-modal="false"
      center
    >
      <!-- style="height: 300px;" -->
      <div style="padding-left:100px;">
        <el-steps direction="vertical" :active="10">
          <el-step
            :title="item.title"
            v-for="(item, index) in processLine"
            :description="item.desc"
            :key="index"
          ></el-step>
        </el-steps>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="auditStepVisible = false"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <el-dialog
      title="申诉"
      :visible.sync="complainVisible"
      width="660px"
      :close-on-click-modal="false"
      center
    >
      <el-form
        ref="addAuditForm"
        :rules="addAuditRules"
        label-width="120px"
        :model="addAuditForm"
        size="medium"
      >
        <el-row>
          <el-form-item label="异议日期" prop="objectionDate">
            <el-row style="color:red;text-index:50;"
              >异议日期不要选当天，要选过去某天金额有误的日期</el-row
            >
            <el-date-picker
              style="width:300px"
              v-model="addAuditForm.objectionDate"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="异议金额" prop="complainFee" style="width:420px">
            <!-- style="width:215px" -->
            <el-input v-model="addAuditForm.complainFee" clearable></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            label="修正金额"
            prop="correctErrorFee"
            style="width:420px"
          >
            <!-- style="width:215px" -->
            <el-input
              v-model="addAuditForm.correctErrorFee"
              clearable
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="申诉描述" prop="complainDesc">
            <el-input
              type="textarea"
              style="width:420px"
              :rows="3"
              placeholder="请输入申诉描述"
              v-model="addAuditForm.complainDesc"
            ></el-input>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item label="图片上传:" prop="mark"></el-form-item>
        </el-row>
        <!-- <el-row> -->
        <el-upload
          :action="addFile"
          :on-change="handleOnChange"
          :file-list="addAuditImgList"
          :limit="5"
          :on-exceed="uploadOverrun"
          :auto-upload="false"
          :on-remove="handleRemove"
          accept=".jpg, .jpeg, .png, .gif"
          list-type="picture-card"
        >
          <i class="el-icon-plus" />
        </el-upload>
        <!-- </el-row> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="complainVisible = false">取 消</el-button>
        <el-button type="primary" @click="confAddAudit('addAuditForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import moment from "moment";
import Pagination from "./common/Pagination";
import Service from "../script/api/service";
import globalData from "@/components/common/globaldata/global.data.vue";
export default {
  components: { Pagination },
  data() {
    var checkNum = (rule, value, callback) => {
      console.log(value);
      // let reg=/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      let reg = /(^([-]?)[1-9]([0-9]+)?(.[0-9]{1,2})?$)|(^([-]?)(0){1}$)|(^([-]?)[0-9].[0-9]([0-9])?$)/;
      if (value == "") {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的金额格式，最多两位小数点"));
      } else {
        callback();
      }
    };
    return {
      complainVisible: false,
      addAuditInfo: {},
      addAuditImgList: [],
      addFile: Service.addFile + globalData.userInfo.userAccount,
      processLine: [],
      auditStepVisible: false,
      auditVisible: false,
      auditForm: {
        result: "2",
        rejectReason: "",
        affirmFee: ""
      },
      auditRules: {
        result: [
          { required: true, message: "请选择处理决定", trigger: "change" }
        ],
        affirmFee: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入裁定金额", trigger: "change" }
        ]
      },
      cityList: [],
      stationList: [],
      listData: [],
      total: 0,
      pageSize: 10,
      currentPage: 1, //当前页
      listQuery: {
        cityId: "",
        stationId: "",
        name: "",
        phone: "",
        type: "",
        firstAuditStatus: "",
        secondAuditStatus: "",
        timePart: []
      },
      typeMap: {
        // 1: "鲸选补贴",
        // 2: "新农保补贴",
        // 3: "杂费",
        // 4: "申诉金额",
        // 5: "工单计提",
        // 6: "保险费",
        // 7: "跟单费",
        // 8: "住宿费",
        // 9: "宿舍费补贴",
        // 10: "师傅奖"
      },
      stepMap: {
        1: "待首次审核",
        2: "驳回(首次审核驳回)",
        3: "待复审(首次审核通过)",
        4: "驳回（复审驳回）",
        5: "审批完成(复审通过)",
        6: "审核超时(初审超时)",
        7: "审核超时（复审超时）"
      },
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近半个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      addAuditRules: {
        complainFee: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入异议金额", trigger: "change" }
        ],
        correctErrorFee: [
          { validator: checkNum, trigger: "blur" },
          { required: true, message: "请输入修正金额", trigger: "change" }
        ],

        complainDesc: [
          { required: true, message: "请输入申诉描述", trigger: "change" }
        ],
        objectionDate: [
          { required: true, message: "请选择异议日期", trigger: "change" }
        ]
      },
      addAuditForm: {
        complainFee: "",
        correctErrorFee: "",
        objectionDate: "",
        complainDesc: ""
      }
    };
  },
  created() {
    this.cityList = JSON.parse(window.localStorage.getItem("allCityList"));
    if (!window.localStorage.getItem("allCityList")) {
      Service.$axiosGetAllCityStation({
        // userId:  JSON.parse(window.localStorage.getItem("userInfo")).id
      }).then(res => {
        if (res.data.errno == "0") {
          this.cityList == res.data.data;
          window.localStorage.setItem(
            "allCityList",
            JSON.stringify(this.cityList)
          );
        } else {
          this.$message.warning(res.data.errmsg);
        }
      });
    }
    Service.$axiosGetAllSalaryType()
            .then((res) => {
              let tt={};
              res.data.data.forEach(f=>{
                tt[f.id]=f.salaryTypeName;
              });
              this.typeMap=tt;
            })
            .catch((err) => {
                console.log(err);
            });

    this.querySearch();
  },
  methods: {
    //查询
    querySearch() {
      let temp = {
        cityId: this.listQuery.cityId,
        stationId: this.listQuery.stationId,
        name: this.listQuery.name,
        phone: this.listQuery.phone,
        type: this.listQuery.type,
        firstAuditStatus: this.listQuery.firstAuditStatus,
        secondAuditStatus: this.listQuery.secondAuditStatus,
        page: this.currentPage,
        size: this.pageSize
      };
      if (
        this.listQuery.timePart != "" &&
        this.listQuery.timePart != undefined
      ) {
        temp.createTimeStart = this.listQuery.timePart[0]
          .getTime()
          .toString()
          .substr(0, 10);
        temp.createTimeEnd = this.listQuery.timePart[1]
          .getTime()
          .toString()
          .substr(0, 10);
      }
      Service.$axiosAuditList(temp)
        .then(res => {
          this.listData = res.data.data.list;
          this.total = res.data.data.total;
        })
        .catch(err => {
          console.log(err);
        });
    },
    cityChange(value) {
      this.listQuery.stationId = "";
      let currentStation = this.cityList.filter(item => {
        return item.id == value;
      });
      this.stationList = currentStation[0].stationList;
    },
    dateChange(e) {
      if (e != null) {
        let start =
          new Date(e[0]).getFullYear() * 12 + new Date(e[0]).getMonth();
        let end = new Date(e[1]).getFullYear() * 12 + new Date(e[1]).getMonth();
        let isOvertime = end - start - 12 > 0;
        // if (isOvertime) {
        //   this.$message.warning("选中时间范围不能超过一年");
        //   this.listQuery.timePart = null;
        // }
      }
    },
    auditShow(row) {
      this.auditVisible = true;
      this.auditInfo = row;
      this.auditForm = {
        result: "2",
        rejectReason: "",
        affirmFee: ""
      };
    },
    confAudit() {
      this.$refs["auditForm"].validate(valid => {
        if (valid) {
          let params = {
            auditId: this.auditInfo.id,
            result: this.auditForm.result,
            affirmFee: this.auditForm.affirmFee,
            type:
              this.auditInfo.firstAuditStatus == 1
                ? "1"
                : this.auditInfo.secondAuditStatus == 1
                ? "2"
                : "",
            rejectReason:
              this.auditForm.result == "2" ? "" : this.auditForm.rejectReason
          };

          Service.$axiosProcessAudit(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("提交成功");
              this.auditVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    showAuditDetail(row) {
      this.auditStepVisible = true;
      Service.$axiosAuditDetail({
        auditId: row.id
      }).then(res => {
        if (res.data.errno == 0) {
          this.auditStepVisible = true;
          let process = res.data.data.process;
          let processLine = [];
          process.forEach(item => {
            let person =
              item.firstAuditPersonName != ""
                ? "一级审核人:" + item.firstAuditPersonName
                : "" +
                  " " +
                  (item.secondAuditPersonName != ""
                    ? "二级审核人:" + item.secondAuditPersonName
                    : "");
            let obj = {
              title: this.stepMap[item.step],
              desc: person + " " + this.formateTime(item.createTime)
            };
            processLine.push(obj);
          });
          this.processLine = processLine.reverse();
        } else {
          this.$message.error(res.data.data);
        }
      });
    },
    addComplain(row) {
      this.complainVisible = true;
      this.addAuditInfo = row;
      this.addAuditForm = {
        complainFee: row.complainFee,
        correctErrorFee: "",
        objectionDate: "",
        complainDesc: ""
      };
    },

    confAddAudit(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let auditImg = this.addAuditImgList.map(item => {
            return item.url;
          });
          console.log(this.addAuditInfo);
          let params = {
            oldComplainId: this.addAuditInfo.id,
            serverNo: this.addAuditInfo.serverId,
            type: this.addAuditInfo.type,
            relationId: this.addAuditInfo.relationId,
            file: auditImg.join(","),
            complainFee: this.addAuditForm.complainFee,
            correctErrorFee: this.addAuditForm.correctErrorFee,
            objectionDate: this.addAuditForm.objectionDate,
            complainDesc: this.addAuditForm.complainDesc
          };

          Service.$axiosAddNewComplain(params).then(res => {
            if (res.data.errno == 0) {
              this.$message.success("提交成功");
              this.complainVisible = false;
              this.querySearch();
            } else {
              this.$message.error(res.data.data);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    uploadOverrun: function() {
      this.$message({
        type: "error",
        message: "上传文件个数超出限制!最多上传5张图片!"
      });
    },
    handleRemove: function(file, fileList) {
      console.log(file, fileList);
      this.addAuditImgList = fileList;
    },
    handleOnChange(file, fileList) {
      console.log(file);
      console.log(fileList);
      if (file.raw) {
        console.log("上传文件大小" + file.raw.size);
        let param = new FormData();
        param.append("createAccount", globalData.userInfo.userAccount);
        param.append("file", file.raw);
        Service.$ajaxAddFile(param).then(res => {
          console.log(res);
          if (res.data.errno == 0) {
            console.log(res);
            file.url = res.data.data.fileUrl;
            this.addAuditImgList = fileList;
            console.log(this.addAuditImgList);
            //  let url=this.prewWorkerImg(res.data.data.id);
            //  this.skillImgList.push(res.data.data.fileUrl);
          }
        });
      }
    },
    salaryDetail(row) {
      let id = row.relationId;
      this.$router.push({
        path: "/salaryManage/salaryDetailList",
        query: {
          id: id
        }
      });
    }
  }
};
</script>
<style scoped>
.crumbs {
  margin: 0 0 10px 0;
}
.btn-margin .el-button--small {
  margin: 10px 12px 0 0;
}
 .el-step__description.is-finish {
  color: #333;
}
 .el-step.is-vertical {
  flex-basis: auto !important;
  height: 80px;
}
.el-image img {
  height: 60px;
  width: 60px;
  margin: 0 12px 12px 0;
  object-fit: cover;
}
</style>
